export default {
  language: "en",
  des:
    "مادیا یک پلتفرم آموزشی برای یادگیری و آموزش آنلاین می باشد که در آن مخاطبین مهارت های جدیدی را جهت دستیابی به اهداف خود با استفاده از کاملترین دوره های های آموزشی تدریس شده توسط بهترین مدرسین به دست می‌آورند. هدف مادیا، ارتقای سطح کیفیت زندگی و فضای کسب دانش و کار, از طریق آموزش‌های آنلاین می‌باشد.",
  nameApp: "Madya Online Courses | آموزش های آنلاین مادیا",
  meta: {
    title: {
      creator: "اطلاعات مدرس",
      login: "ورود به مادیا",
      basket: "سبد خرید",
      tuition: "شروع تدریس",
      instructorRequest: "در خواست تدریس",
      myCourses: "دوره های منو",
      content: "محتوای آموزشی",
      listContent: "لیست محتوای آموزشی",
      courseDescription: "توضیحات",
      discuss: "پرسش و پاسخ",
      comments: "نظرات",
      category: "دسته بندی",
      courseDetails: "جزییات دوره",
      about: "درباره مادیا",
      termsOfUse: "شرایط  و قوانین استفاده از مادیا"
    }
  },
  button: {
    login: "ورود",
    signIn: "ثبت نام",
    imUser: "نام کاربری دارم!",
    addCart: "افزودن به سبد خرید",
    details: "جزییات بیشتر",
    courseStart: "ثبت نام در دوره",
    favorite: "افزودن به لیست علاقه مندی ها",
    listCard: "لیست سبد خرید",
    showAllCard: "نمایش سبد خرید",
    removeCard: "حدف محصول",
    submitCard: "ثبت نهایی",
    getStartedTuition: "ارسال ویدئو نمونه و شروع تدریس",
    continueCourses: "ادامه آموزش"
  },
  title: {
    lastCourse: "جدید ترین دوره ها"
  },
  label: {
    username: "نام کاربری",
    name: "نام",
    family: "نام خانوادگی",
    fullname: "نام نام خانوادگی ",
    email: "ایمیل",
    password: "گذرواژه",
    re_password: "تایید گذرواژه",
    newPassword: "گذر واژه جدید",
    sex: "جنسیت",
    male: "مرد",
    female: "زن",
    searsh: "جستجو ..."
  },
  menu: {
    home: "صفحه اصلی",
    tuition: "تدریس",
    myCourses: "دوره های من",
    learning: "لیست دوره های",
    Content: "محتوای دوره",
    listContent: "لیست محتوای دوره ه",
    FandQ: "پرسش و پاسخ",
    exit: "خروج",
    mags: "مقالات",
    instructorRequest: "درخواست تدریس",
    about: "درباره مادیا",
    termsOfUse: "شرایط  و قوانین استفاده از مادیا"
  },
  dashboardMenu: {
    user: "کاربران",
    dashboard: "داشبورد",
    profile: "حساب کاربری",
    favorite: "علاقه مندی ها",
    myTickets: "تیکت های من",
    myPayment: "سوابق مالی",
    category: "دسته بندی ها",
    subcategory: "زیر شاخه ها",
    tag: "تگ ها",
    users: "کاربران",
    allcourses: "دوره ها",
    comments: "نظرات",
    discusses: "پرسش و پاسخ",
    tickets: "تیکت ها",
    offers: "تخفیف ها",
    abuse: "گزارش تخلف",
    blog: "بلاگ",
    monitoring: "مانیتورینگ",
    payment: "مالی و حساب داری",
    rules: "قوانین",
    courseForm: "اطلاعات اولیه دوره",
    instructors: "مدرسین",
    sections: "فصل ها",
    goals: "اهداف دوره",
    messages: "پیام های دوره",
    offercode: "کد های تخفیف",
    mycourses: "دوره های من",
    password: "تغییر کلمه عبور",
    blogList:'لیست مقالات',
    blogEdit:'ویرایش مقالات'
  },

  word: {
    of: "از",
    rate: "رای",
    comments: "نظرات",
    rial: "ریال",
    toman: "تومان"
  },
  msg: {
    welcome: `خوش آمدید`
  },
  message: {
    require: {
      error: {
        username: "نام کاربری را وارد کنید",
        fullname: "نام نام خانوادگی را وارد کنید ",
        email: "ایمیل را وارد کنید",
        password: "گذرواژه را وارد کنید ( < 8 کاراکتر) و شامل اعداد",
        re_password: "تکرار گذرواژه باید مشابه گذرواژه باشد",
        newPassword: "گذرواژه جدید را وارد کنید"
      }
    },
    request: {
      someProblem: "مشکلی پیش آمده است",
      catchInRequest: "مشکل در درخواست",
      done: "با موفقیت انجام شد"
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/fa.js